import { NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { AccordionComponent } from './components/accordion';
import { AutosizeDirective } from './directives/autosize';
import { CapitalizePipe } from './pipes/capitalize';
import { DayOfWeekPipe } from './pipes/day-of-week';
import { SearchPipe } from './pipes/search';
var SoftwaredataModule = (function () {
    function SoftwaredataModule() {
    }
    SoftwaredataModule.forRoot = function () {
        return {
            ngModule: SoftwaredataModule,
            providers: []
        };
    };
    SoftwaredataModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        IonicModule
                    ],
                    declarations: [
                        AccordionComponent,
                        AutosizeDirective,
                        CapitalizePipe,
                        DayOfWeekPipe,
                        SearchPipe
                    ],
                    exports: [
                        AccordionComponent,
                        AutosizeDirective,
                        CapitalizePipe,
                        DayOfWeekPipe,
                        SearchPipe
                    ]
                },] },
    ];
    /** @nocollapse */
    SoftwaredataModule.ctorParameters = function () { return []; };
    return SoftwaredataModule;
}());
export { SoftwaredataModule };
//# sourceMappingURL=softwaredata.module.js.map


//////////////////
// WEBPACK FOOTER
// ../ionic-commons/dist/softwaredata.module.js
// module id = 861
// module chunks = 0